<template>
    <div class="resourcePage">
        <div class="leftPage">
            <v-left ref="left" />
        </div>
        <div class="middlePage">
            <v-middle ref="middle" />
        </div>
    </div>
</template>

<script>
import LeftContentVue from './components/LeftContent.vue';
import MiddleContentVue from './components/MiddleContent.vue';
export default {
    components: {
        'v-left':LeftContentVue,
        'v-middle':MiddleContentVue,
    },
    data(){
        return {
        }
    },
    methods:{
    }
}
</script>

<style lang="scss" scoped>
.resourcePage {
    height: 100%;
    width: 100%;
    display: flex;
    .leftPage {
        width: 300px;
        height: 100%;
        box-sizing: border-box;
    }
    .middlePage {
        width: calc(100% - 300px);
        box-sizing: border-box;
        padding: 0 15px;
    }
}
</style>